import { useMutation, useQueryClient } from '@tanstack/react-query'

import { getMeQueryOptions } from '../../auth/services/useMeQuery'
import { intentionApi } from '../api/intentionApi'
import type { TEditIntentionPayload } from '../api/types/editIntentionApi.types'

export const useEditIntentionMutation = (payload: TEditIntentionPayload) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (intentionId: number) => intentionApi.editIntention(intentionId, payload),

    onSuccess: ({ content }) => {
      queryClient.setQueryData(
        getMeQueryOptions().queryKey,
        (data) => data && { ...data, intention: data.intention && { ...data.intention, content } },
      )
    },
  })
}
